import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ParamsObject } from '../../utils/api.service';
import { Room, RoomBooking } from '../../models';
import { map } from 'rxjs/operators';


@Injectable()
export class RoomService {
  constructor(
    private apiService: ApiService,
  ) {}

  delete(room) {
    return this.apiService.delete(`rooms/${room.id}`);
  }

  get(id: string): Observable<Room> {
    return this.apiService.get(`rooms/${id}`);
  }

  getAll(params: ParamsObject = null): Observable<Room[]> {
    const httpParameters = new HttpParams({
      fromObject: params,
    });

    return this.apiService.get(`rooms`, httpParameters);
  }

  /**
   * Returns room bookings depending on search parameters
   *
   * @param roomId Room identifier
   * @param params Search params to apply to the request
   */
  getRoomBookings(roomId: string, params: HttpParams = new HttpParams()): Observable<RoomBooking[]> {
    return this.apiService
      .get(`rooms/${roomId}/room_bookings`, params)
      .pipe(
        map(data => {
          data['hydra:member'].map(obj => new RoomBooking(obj));
          return data;
        }),
      );
  }

  /**
   * Check room availability according to search parameters
   *
   * @param roomId Room identifier
   * @param params Search params to apply to the request
   * @return Observable of boolean indicating room availability
   */
  checkRoomAvailability(roomId: string, params: HttpParams = new HttpParams()): Observable<{available: boolean}> {
    return this.apiService.get(`rooms/${roomId}/room_bookings/check_availability`, params);
  }

  save(room): Observable<Room> {
    const keywordToDestructSubject = ['getBuildingRooms'];
    if (room.id) {
      return this.apiService.put(`rooms/${room.id}`, room, '', keywordToDestructSubject);
    } else {
      return this.apiService.post(`rooms`, room, '', keywordToDestructSubject);
    }
  }

  saveRoomPicture(room): Observable<Room> {
    if (room.id) {
      return this.apiService.put(`rooms/${room.id}/pictures`, { pictures : room.pictures });
    }
  }

}
